<div class="scaffold-wizard-holder" [ngClass]="{'tab-style-wizard':item.use_tab_style}">
  <h2>{{item.translation_key||item.title| translation|translationFromString | transformText :item?.text_transform}}</h2>
  <nb-stepper [orientation]="item.direction" #stepper [linear]="false">
    <nb-step *ngFor="let step of item.tabs; let $index = index" [label]="step.heading">
      <div>
        <app-view [active]="selectedStep === $index" [childview]="item.childview || childview" [info]="info" [items]="step.content" [data]="data" (openViewHandler)="openViewHandler($event, ite)" (moveHandler)="openMove()" (openLinkHandler)="openLinkHandler($event, ite)"></app-view>

      </div>
      <div>
        <button nbButton nbStepperPrevious color="primary" [disabled]="$index===0"><span>{{'previous'| translation}}</span><span *ngIf="$index > 0">: {{item.tabs[$index - 1].translation_key_label||item.tabs[$index - 1].heading| translation|translationFromString | transformText :item?.text_transform_label}}</span></button>
        <button nbButton nbStepperNext color="primary" [disabled]="$index >= item.tabs.length-1"  class="pull-right"><span>{{'next'| translation}}</span><span *ngIf="$index < item.tabs.length-1">: {{item.tabs[$index + 1].translation_key_label||item.tabs[$index + 1].heading| translation|translationFromString | transformText :item?.text_transform_label}}</span></button>
      </div>

    </nb-step>
  </nb-stepper>

</div>
